import { BonsaiRole, Role } from 'src/@types/role';
import RoleBasedGuard from 'src/guards/RoleBasedGuard';
import { IdIssuanceManagementPage } from '../pages/IdIssuanceManagementPage';

const accessibleRoleList: Role[] = [BonsaiRole.ADMIN, BonsaiRole.VIEWER_ADMIN];

export const idIssuanceManagementRoute = {
  path: 'id-issuance-management',
  element: (
    <RoleBasedGuard accessibleRoles={accessibleRoleList}>
      <IdIssuanceManagementPage />
    </RoleBasedGuard>
  ),
};
